// @ts-nocheck
import React from 'react';
import { Users, UserPlus } from 'lucide-react';

export function CustomerStatsCard({ stats }) {
  if (!stats) return null;

  return (
    <>
      {/* 総顧客数 */}
      <div className="bg-white p-6 rounded-lg shadow">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600">総顧客数</p>
            <p className="text-3xl font-bold mt-2">{stats.totalCustomers || 0}</p>
          </div>
          <div className="p-3 bg-blue-100 rounded-full">
            <Users className="text-blue-600" size={24} />
          </div>
        </div>
      </div>

      {/* 新規顧客数 */}
      <div className="bg-white p-6 rounded-lg shadow">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600">新規顧客</p>
            <p className="text-3xl font-bold mt-2">{stats.newCustomers || 0}</p>
          </div>
          <div className="p-3 bg-green-100 rounded-full">
            <UserPlus className="text-green-600" size={24} />
          </div>
        </div>
      </div>
    </>
  );
}
